/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Takımınızdan veya yöneticinizden yardım isteyin.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'Bu aramanız için hiçbir sonuç alınamadı'
};